import { Input, Modal, Typography } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

const { Text } = Typography

interface RejectReviewModalProps {
  fileName: string
  onClose: () => void
  onSubmit: (reason: string) => Promise<void>
}

export function RejectReviewModal({ fileName, onClose, onSubmit }: RejectReviewModalProps) {
  const { t } = useTranslation()
  const [reason, setReason] = useState("")
  const [saving, setSaving] = useState(false)

  const handleSubmit = async () => {
    if (!reason.trim()) return
    setSaving(true)
    await onSubmit(reason.trim())
    setSaving(false)
  }

  return (
    <Modal
      open
      title={t("files.review.rejectTitle")}
      onCancel={onClose}
      okText={t("files.review.rejectSubmit")}
      okButtonProps={{ danger: true, disabled: !reason.trim(), loading: saving }}
      onOk={() => void handleSubmit()}
      cancelButtonProps={{ disabled: saving }}
    >
      <div className="flex flex-col gap-2">
        <Text type="secondary">{fileName}</Text>
        <Text type="secondary">{t("files.review.rejectReason")}</Text>
        <Input.TextArea
          autoFocus
          disabled={saving}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder={t("files.review.rejectReasonPlaceholder")}
          rows={3}
          maxLength={1000}
        />
      </div>
    </Modal>
  )
}
